import { useEffect } from 'react';
import styles from './index.module.sass';
import { CHANGE_CURRENT_PAGE, PAGE_DRIVERS, useAppContext } from 'use-app';
import { DriversContent } from './drivers-content';
import analytics from 'service/analytics';

const Drivers = () => {
  const { dispatch: appDispatch, state } = useAppContext();
  const me = state.me || null;

  // The user is not subAccount or the user has the permission to read the driver page
  const isUserAllowedToReadDriverPage = Boolean(me?.subAccount == null || me.subAccount.enterpriseDriverRead);

  // The user is not subAccount or the user has the permission to write the driver page
  const isUserAllowedToWriteDriverPage = Boolean(me?.subAccount == null || me.subAccount.enterpriseDriverWrite);

  useEffect(() => {
    analytics.driversPagePageview();
  }, []);

  useEffect(() => {
    appDispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_DRIVERS,
    });
  }, [appDispatch]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>駕駛帳號</div>
      <div className={styles.desc} style={{ marginBottom: 20 }}>
        新增駕駛帳號後，該駕駛即可使用加油條碼付款，請仔細管理您的駕駛名單。
      </div>
      {isUserAllowedToReadDriverPage ? (
        <DriversContent isUserAllowedToWriteDriverPage={isUserAllowedToWriteDriverPage} />
      ) : (
        <div className={styles['empty']}>權限不足無法瀏覽</div>
      )}
    </div>
  );
};

export default Drivers;
